module.exports = __webpack_public_path__ + "static/16.6_Later_Middle_Ages-76d99855df86846996a511772631ba3a.pdf";